/**
 * Checks if an image exists and has non-zero dimensions.
 *
 * @param image The image to check.
 * @returns True if the image exists and has non-zero dimensions, false otherwise.
 */
export const checkImageExists = (
  image: HTMLImageElement | null | undefined
) => {
  if (!image) return false;
  if (image.width === 0 || image.height === 0) return false;
  return true;
};
